/**
 * Zeigt die Halsbandfarbe eines Welpen als Punkt mit Beschriftung.
 *
 * Der Punkt ist nur eine Lesehilfe - die Beschriftung steht immer daneben,
 * damit die Angabe auch bei Farbenblindheit oder unbekanntem Farbnamen lesbar bleibt.
 */

import { useTranslation } from 'react-i18next';
import { collarColorKeyFor, COLLAR_COLOR_SWATCHES, LEGACY_COLOR_SWATCHES } from '../utils/collarColor';

interface CollarBadgeProps {
  color: string;
  className?: string;
}

export const CollarBadge: React.FC<CollarBadgeProps> = ({ color, className }) => {
  const { t } = useTranslation();
  const key = collarColorKeyFor(color);
  // Ueber die feste Auswahl erfasste Farben werden in die aktuelle Sprache uebersetzt, aeltere Freitext-Eintraege bleiben unveraendert sichtbar.
  const label = key ? t(`breeding:plan.collarColors.${key}`) : color;
  const swatch = key ? COLLAR_COLOR_SWATCHES[key] : LEGACY_COLOR_SWATCHES[color.trim().toLowerCase()];

  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1.5 rounded-full border border-dark-600 bg-dark-800/80 px-2 py-0.5 text-xs text-dark-200 ${className ?? ''}`}
      title={t('breeding:collarBadge.label', { color: label })}
    >
      <span
        aria-hidden="true"
        className="h-2.5 w-2.5 shrink-0 rounded-full border border-black/30"
        // Unbekannte Farbnamen bekommen einen neutralen Punkt statt gar keinem
        style={{ backgroundColor: swatch ?? '#6b7280' }}
      />
      {label}
    </span>
  );
};
